import React from 'react';
import './SimpleHero.css';

const SimpleHero = ({
  title = 'Welcome to GN Bank',
  subtitle = 'Simple, transparent banking for everyone.',
  primaryLabel = 'Open an account',
  primaryHref = '/DirectDeposit',
  secondaryLabel,
  secondaryHref,
  align = 'center', // 'center' | 'left'
  variant = 'light', // 'light' | 'muted' | 'sofi'
  imageSrc,
  imageAlt = '',
  imageOn = 'right', // 'right' | 'left'
  tiltImage = false,
  badges = [], // array of strings
}) => {
  const hasImage = Boolean(imageSrc);
  return (
    <section className={`simple-hero simple-hero--${variant}`}>
      <div className="gn-container">
        <div className={`simple-hero__grid ${imageOn === 'left' ? 'simple-hero__grid--image-left' : ''}`}>
          {hasImage && imageOn === 'left' && (
            <div className={`simple-hero__image ${tiltImage ? 'simple-hero__image--tilt' : ''}`}>
              <img src={imageSrc} alt={imageAlt} />
            </div>
          )}
          <div className={`simple-hero__inner simple-hero__inner--${align}`}>
            <h1 className="simple-hero__title">{title}</h1>
            {subtitle && <p className="simple-hero__subtitle">{subtitle}</p>}
            {badges && badges.length > 0 && (
              <div className="simple-hero__badges">
                {badges.map((b, i) => (
                  <span className="hero-badge" key={i}>{b}</span>
                ))}
              </div>
            )}
            <div className="simple-hero__ctas">
              {primaryLabel && (
                <a className="btn btn-gn-primary" href={primaryHref}>{primaryLabel}</a>
              )}
              {secondaryLabel && secondaryHref && (
                <a className="btn btn-gn-secondary ms-2" href={secondaryHref}>{secondaryLabel}</a>
              )}
            </div>
          </div>
          {hasImage && imageOn === 'right' && (
            <div className={`simple-hero__image ${tiltImage ? 'simple-hero__image--tilt' : ''}`}>
              <img src={imageSrc} alt={imageAlt} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SimpleHero;


